import { disableScroll } from '../functions/disable-scroll';
import { enableScroll } from '../functions/enable-scroll';
export default function modal() {
    let modals = document?.querySelectorAll('.modal-wrapper[data-modal]'),
        buttons = document?.querySelectorAll('[data-modal]:not(.modal-wrapper)');
        // setDark = ()=>{
        //     document.querySelector('.section--howto').classList.add('section--howto-dark')
        //     document.querySelector('.section--howto .section__title').classList.remove('section__title--black')
        //     document.querySelector('.section--howto .section__desc').classList.remove('section__desc--dark')
        //     document.querySelector('.scores').classList.add('scores--dark')
        //     document.querySelector('.scores-cards').classList.add('scores-cards--dark')
        // },
        // removeDark = ()=>{
        //     document.querySelector('.section--howto').classList.remove('section--howto-dark')
        //     document.querySelector('.section--howto .section__title').classList.add('section__title--black')
        //     document.querySelector('.section--howto .section__desc').classList.add('section__desc--dark')
        //     document.querySelector('.scores').classList.remove('scores--dark')
        //     document.querySelector('.scores-cards').classList.remove('scores-cards--dark')
        // };
    modals.forEach(modal=>{
        modal.querySelector('.modal__close').addEventListener('click', ()=>{
            // removeDark()
            modal.setAttribute('is-open', false)
            enableScroll()
        })
        modal.addEventListener('click', (e)=>{
            let withinBoundaries = !e.composedPath().includes(modal.querySelector('.modal'));
            if(withinBoundaries) {
                // removeDark();
                modal.setAttribute('is-open', false);
                enableScroll();
            }
        })
        window.addEventListener('keydown', (e)=>{
            if(e.key === "Escape" && modal.getAttribute('is-open') == 'true') {
                // removeDark();
                modal.setAttribute('is-open', false);
                enableScroll();
            }
        })
    });
    buttons.forEach(button=>{
        let target = button?.dataset?.modal
        button.addEventListener('click', ()=>{
            modals.forEach(modal=>{
                modal.dataset.modal === target ? modal.setAttribute('is-open', true) : modal.setAttribute('is-open', false)
                if(modal.getAttribute('is-open') == 'true')
                    disableScroll();
                // if((modal.dataset.modal === 'merch' || modal.dataset.modal === 'tickets' || modal.dataset.modal === 'subscriptions' || modal.dataset.modal === 'food') && modal.getAttribute('is-open') == 'true') {
                //     setDark()
                // }
            })
        })
    });
}